// extracted by mini-css-extract-plugin
export default {"contact-form":"Form_contact-form__OIIBC","error-message":"Form_error-message__DiNXa","sent-message":"Form_sent-message__fvk5J"};